
import { defineComponent, ref, PropType } from "vue";
import { Ref } from "vue";
import { formattedDuration } from "../../mixins";
import { ContentType } from "../../../../../domain/entities/content/content";
import TUIViewer from "../TUIViewer.vue";
import { Content } from "../../../views/content/helpers";

export default defineComponent({
  name: "AccordionItem",
  components: { TUIViewer },
  props: {
    content: {
      type: Object as PropType<Content>
    }
  },
  setup(props) {
    const active: Ref<boolean> = ref(false);

    const toggle = (): void => {
      active.value = !active.value;
    };

    const correctText = (): number | string => {
      if (props.content) {
        switch (props.content?.type) {
          case ContentType.EXERCISE:
            return `${props.content?.exercise?.numberOfQuestions} perguntas`;
          case ContentType.PDF:
            return formattedDuration(props.content?.duration);
          case ContentType.SCORM:
            return formattedDuration(props.content?.duration);
          case ContentType.YOUTUBE:
            return formattedDuration(props.content?.duration);
          case ContentType.MP3:
            return formattedDuration(props.content?.duration);
        }
      }
      return 0;
    };

    return {
      active,
      ContentType,
      toggle,
      formattedDuration,
      correctText
    };
  }
});
